import { BrowserNotificationService } from './browser-notification'
import { ChatClientService } from './chat-client'
import { MessageService } from './message'
import { searchClient } from './search-client'
import { TokenService } from './token-service'

/* Token service */
const tokenService = new TokenService()

/* Browser notification service */
const browserNotificationService = new BrowserNotificationService()

/* Chat client service */
const chatClientService = new ChatClientService(tokenService, browserNotificationService)

const messageService = new MessageService(tokenService)

export { browserNotificationService, chatClientService, messageService, searchClient, tokenService }
